import { render, staticRenderFns } from "./kycModal.vue?vue&type=template&id=46c94ee1&scoped=true&"
import script from "./kycModal.vue?vue&type=script&lang=js&"
export * from "./kycModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c94ee1",
  null
  
)

export default component.exports